import { DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { BaseTableComponent } from '../../../models/base-table-component.model';
import { OpsStreamType } from '../../../models/filters.model';
import { HandoverColumnKey } from '../../../models/handover-column.model';
import { DueTagLabel, HandoverLog } from '../../../models/handover-log.model';
import { HANDOVER_COLUMNS } from './handover-table-config';
import { ZebraShadowRowsDirective } from '../../../shared/directives/zebra-shadow-rows/zebra-shadow-rows.directive';
import { AppTagComponent, TagVariant } from '../../../shared/components/app-tag/app-tag.component';

@Component({
  selector: 'dr-ops-stream-ui-handover-table',
  templateUrl: './handover-table.component.html',
  styleUrls: ['./handover-table.component.scss'],
  imports: [ZebraShadowRowsDirective, AppTagComponent, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HandoverTableComponent extends BaseTableComponent<HandoverLog, HandoverColumnKey> {
  private static readonly DUE_SOON_WINDOW_MS = 5 * 60 * 1000;
  readonly selectedOpsStreamTypeSignal = input.required<OpsStreamType>({ alias: 'selectedOpsStreamType' });
  readonly opsStreamType = OpsStreamType;

  viewLog = output<HandoverLog>();
  editLog = output<HandoverLog>();

  constructor() {
    super(signal(HANDOVER_COLUMNS));
  }

  protected onView(log: HandoverLog) {
    this.viewLog.emit(log);
  }

  protected onEdit(log: HandoverLog) {
    this.editLog.emit(log);
  }

  toDate(value: string | Date | null | undefined): Date | null {
    if (!value) return null;
    if (value instanceof Date) return value;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
}
